import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=6678b0c3&scoped=true&"
import script from "./FormDetails.vue?vue&type=script&lang=js&"
export * from "./FormDetails.vue?vue&type=script&lang=js&"
import style1 from "./FormDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678b0c3",
  null
  
)

export default component.exports